<div class="container p-a-m">
    <div #knobContainer class="switch-container">
        <div #knob id="sliderKnob" class="slider" [ngClass]="{'knob-off': !state, 'knob-on': state}">
            {{state ? 'An'.toUpperCase() : 'Aus'.toUpperCase()}}
        </div>
        <div #indicator class="indicator" [ngClass]="{'indicator-off': !state, 'indicator-on' : state}"></div>
    </div>
</div>
